import type { DigioProviderConfig } from "@/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx";
import { loadScript } from "@/utils/loadScript.ts";

export type DigioSDKConstructor = new (options: { environment: "sandbox" | "production" }) => DigioSDK;

export interface DigioSDK {
    init: () => void;
    submit: (requestId: string, identifier: string, tokenId?: string) => void;
}

declare global {
    interface Window {
        Digio: DigioSDKConstructor;
    }
}

export async function digioLoader(config: DigioProviderConfig): Promise<{ digio: DigioSDKConstructor }> {
    if (window.Digio) {
        return { digio: window.Digio };
    }

    const url = config.test_mode
        ? new URL("https://ext-gateway.digio.in/sdk/v11/digio.js")
        : new URL("https://app.digio.in/sdk/v11/digio.js");

    await loadScript(url.toString());
    return { digio: window.Digio };
}
